module.exports = __webpack_public_path__ + "static/virtuera-9433cfcea7de107bcff7139c4605b137.png";